import { Link } from "react-router-dom";

const CustomLink = (props) => {
	var newprops = {...props}
	newprops.className = "react-router-link " + props.className
	return (
		<Link {...newprops}></Link>
	);
}
 
export default CustomLink;